<div class="container p-3">
    <div class="row">
        <div class="col position-relative">
            <div style="position: absolute; top: 0px; right: 15px;">
                <button class="btn btn-primary" (click)="refreshBanners()">
                    <i class="fas fa-sync-alt"></i> Refresh
                </button>
            </div>
            <h3 (click)="currentBannersVisible = !currentBannersVisible" style="cursor: pointer;">
                Current banners
                <span *ngIf="!currentBannersVisible">
                    <i class="fas fa-caret-right align-text-bottom"></i>
                </span>
                <span *ngIf="currentBannersVisible">
                    <i class="fas fa-caret-down align-text-bottom"></i>
                </span>
            </h3>
            <div [hidden]="!currentBannersVisible">
                <div class="row mb-3" *ngIf="banners && banners.length > 0">
                    <div class="col-4" *ngFor="let banner of banners">
                        <div>
                            <code>#{{ banner.id }}</code>
                        </div>
                        <div>
                            <a href="{{ banner.link }}">
                                <span class="d-block text-truncate">
                                    <i class="fas fa-external-link-alt"></i> {{ banner.link }}
                                </span>
                                <img class="img-fluid w-100" src="{{ banner.url }}">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-sm" [class.btn-info]="filter == null" [class.btn-outline-info]="filter != null" (click)="filter = null">Default</button>
                            <button type="button" class="btn btn-sm" [class.btn-info]="filter == 'ZeTime'" [class.btn-outline-info]="filter != 'ZeTime'" (click)="filter = 'ZeTime'">ZeTime</button>
                            <button type="button" class="btn btn-sm" [class.btn-info]="filter == 'ZeFit4'" [class.btn-outline-info]="filter != 'ZeFit4'" (click)="filter = 'ZeFit4'">ZeFit4</button>
                            <button type="button" class="btn btn-sm" [class.btn-info]="filter == 'ZeRound2'" [class.btn-outline-info]="filter != 'ZeRound2'" (click)="filter = 'ZeRound2'">ZeRound2</button>
                            <button type="button" class="btn btn-sm" [class.btn-info]="filter == 'ZeSport2'" [class.btn-outline-info]="filter != 'ZeSport2'" (click)="filter = 'ZeSport2'">ZeSport2</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col">
            <h3 (click)="newBannerVisible = !newBannerVisible" style="cursor: pointer;">
                Upload a new banner
                <span *ngIf="!newBannerVisible">
                    <i class="fas fa-caret-right align-text-bottom"></i>
                </span>
                <span *ngIf="newBannerVisible">
                    <i class="fas fa-caret-down align-text-bottom"></i>
                </span>
            </h3>
            <div class="background-hover" [hidden]="!newBannerVisible" [formGroup]="newBannerFormGroup">
                <div class="row">
                    <div class="col-7">
                        <div class="mb-3">
                            <label for="newBannerNameInput">Name</label>
                            <input type="text" class="form-control" id="newBannerNameInput" formControlName="newBannerNameInput" placeholder="Name...">
                        </div>
                        <div class="mb-3">
                            <label for="newBannerLinkInput">Link</label>
                            <input type="text" class="form-control" id="newBannerLinkInput" formControlName="newBannerLinkInput" placeholder="https://www.mykronoz.com, https://www.facebook.com/mykronoz, ...">
                        </div>
                        <div class="mb-3">
                            <label>Filters</label>
                            <div>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" id="newBannerActiveCheckbox" formControlName="newBannerActiveCheckbox">
                                    <label class="form-check-label" for="newBannerActiveCheckbox">Default</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" id="newBannerZeTimeCheckbox" formControlName="newBannerZeTimeCheckbox">
                                    <label class="form-check-label" for="newBannerZeTimeCheckbox">ZeTime</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" id="newBannerZeFit4Checkbox" formControlName="newBannerZeFit4Checkbox">
                                    <label class="form-check-label" for="newBannerZeFit4Checkbox">ZeFit4</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" id="newBannerZeRound2Checkbox" formControlName="newBannerZeRound2Checkbox">
                                    <label class="form-check-label" for="newBannerZeRound2Checkbox">ZeRound2</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" id="newBannerZeSport2Checkbox" formControlName="newBannerZeSport2Checkbox">
                                    <label class="form-check-label" for="newBannerZeSport2Checkbox">ZeSport2</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="mb-3">
                            <label>Image</label>
                            <div>
                                <input type="file" accept="image/*" class="form-control" id="newBannerFileInput" (change)="newBannerFileInputChange($event)" formControlName="newBannerFileInput">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <button class="btn btn-primary" [disabled]="newBannerFormGroup.invalid" (click)="uploadNewBanner()">
                        <i class="fas fa-cloud-upload-alt"></i> Upload
                    </button>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col">
            <h3>Configure banners</h3>
            <div *ngIf="adminBanners.length > 0">
                <div *ngFor="let banner of adminBanners">
                    <banner-card [banner]="banner" (refreshBanners)="refreshBanners()"></banner-card>
                    <hr>
                </div>
            </div>
        </div>
    </div>
</div>